import m from './m.js'

/** Logged in user: undefined while loading, null when logged out. */
export const auth = {
  user: undefined,
  async load() {
    try {
      auth.user = await api('GET', '/api/me')
    } catch {
      auth.user = null
    }
  },
  async logout() {
    await m.request({ method: 'POST', url: '/auth/logout' })
    auth.user = null
  },
}

export const toasts = {
  list: [],
  show(text, kind = 'error') {
    const toast = { text, kind }
    toasts.list.push(toast)
    setTimeout(() => {
      toasts.list = toasts.list.filter(t => t !== toast)
      m.redraw()
    }, 6000)
    m.redraw()
  },
}

/** JSON request against our backend; errors carry the server's message and status. */
export async function api(method, url, body) {
  try {
    return await m.request({ method, url, body })
  } catch (err) {
    if (err.code === 401) auth.user = null
    // Mithril's own message is the parsed response, an object, for JSON requests
    const reason = err.code ? `HTTP ${err.code}` : 'no response'
    throw Object.assign(
      new Error(err.response?.error || `Request failed: ${reason}`),
      { status: err.code }
    )
  }
}

export function upload(file) {
  const form = new FormData()
  form.append('file', file)
  return api('POST', '/api/uploads', form)
}
